export enum CustomerGroupField {
  CUSTOMER = 'CUSTOMER',
  TRUSTEE = 'TRUSTEE',
}
